enum Role {
    SUPER_ADMIN = 'super-admin',
    PAYROLL = 'Payroll',
}

export default Role;
